<template>
	<div>
		<v-app>
			<v-overlay :value="attempting" z-index="1000">
				<v-progress-circular
				indeterminate
				size="100"
				></v-progress-circular>
			</v-overlay>
			<v-navigation-drawer v-model="drawer" color="white" app floating :width="navbar" class="nav-shadow">
				<v-list color="white" light>
					<v-list-item>
						<v-list-item-action>
							<v-icon>mdi-warehouse</v-icon>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>Supplier</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-list dense class="pt-0 cus-m-navbar">
					<div>
						<v-list-item link router :to="{name: 'dashboard-supplier'}" color="cyan darken-4">
							<v-list-item-action>
								<v-icon>mdi-home</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Dashboard</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<!-- <v-list-group :prepend-icon="menu.menu_icon" no-action color="purple darken-4" v-if="menu.menu_array">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>{{menu.menu_name}}</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item v-for="submenu in menu.menu_array" >
								<v-list-item-content>
									<v-list-item-title>{{ submenu.menu_name }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group> -->
						<v-list-item link router :to="{name: 'supplier-user'}" color="cyan darken-4">
							<v-list-item-action>
								<v-icon>mdi-account</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Pengguna</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<v-list-item link router :to="{name: 'supplier-product'}" color="cyan darken-4">
							<v-list-item-action>
								<v-icon>mdi-archive-outline</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>Produk</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</div>
					<div>
						<v-list-group prepend-icon="mdi-timer-outline" no-action color="cyan darken-4">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>Jadwal Pengiriman</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item router :to="{name: 'jadwal-pengiriman'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Data Jadwal Pengiriman</span>
											</v-tooltip>
										</span>
										<span v-else>Data Jadwal Pengiriman</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'calendar-pengiriman'}" v-if="false">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Kalender Pengiriman</span>
											</v-tooltip>
										</span>
										<span v-else>Kalender Pengiriman</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
					</div>
					<div>
						<v-list-group prepend-icon="mdi-database-export" no-action color="cyan darken-4">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>Pemesanan</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item router :to="{name: 'list-penjualan'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Data Pemesanan</span>
											</v-tooltip>
										</span>
										<span v-else>Data Pemesanan</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'approval-penjualan'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Approval Pemesanan</span>
											</v-tooltip>
										</span>
										<span v-else>Approval Pemesanan</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item link router :to="{name: 'po-outstanding'}" color="cyan darken-4">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Data Outstanding</span>
											</v-tooltip>
										</span>
										<span v-else>Data Outstanding</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
					</div>
					<div>
						<v-list-group prepend-icon="mdi-truck-delivery-outline" no-action color="cyan darken-4">
							<template v-slot:activator>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-list-item-content v-bind="attrs" v-on="on">
											<v-list-item-title>Pengiriman Pemesanan</v-list-item-title>
										</v-list-item-content>
									</template>
									<span>Pengiriman Pemesanan</span>
								</v-tooltip>
							</template>
							<v-list-item router :to="{name: 'pengiriman'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Data Pengiriman Pemesanan</span>
											</v-tooltip>
										</span>
										<span v-else>Data Pengiriman Pemesanan</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'tambah-pengiriman'}">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-list-item-content v-bind="attrs" v-on="on">
											<v-list-item-title>
												<span v-if="navbar == 60" class="collapse-icon">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</span>
												<span v-else>Tambah Pengiriman Pemesanan</span>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<span>Tambah Pengiriman Pemesanan</span>
								</v-tooltip>
							</v-list-item>
						</v-list-group>
					</div>
					<div>
						<v-list-group prepend-icon="mdi-keyboard-return" no-action color="cyan darken-4">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>Retur</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item router :to="{name: 'list-retur-supplier'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Data Retur</span>
											</v-tooltip>
										</span>
										<span v-else>Data Retur</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'approve-retur-supplier'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Approval Retur</span>
											</v-tooltip>
										</span>
										<span v-else>Approval Retur</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'list-retur-delivery-supplier'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Data Pengiriman Retur</span>
											</v-tooltip>
										</span>
										<span v-else>Data Pengiriman Retur</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item router :to="{name: 'delivery-retur-supplier'}">
								<v-list-item-content>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>Pengiriman Retur</span>
											</v-tooltip>
										</span>
										<span v-else>Pengiriman Retur</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
					</div>
				</v-list>
			</v-navigation-drawer>

			<toolbar v-on:childToParent="clickDrawer" />

			<v-main>
				<v-container class="" fluid>
					<v-row align="center" justify="center">
						<v-col class="pl-5 pr-5">
							<v-snackbar v-model="snackbar.show" timeout="2000" right top :color="snackbar.color">
								{{snackbar.text}}
								<template v-slot:action="{ attrs }">
									<v-btn color="white" text v-bind="attrs" @click="hideSnackbar">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</template>
							</v-snackbar>
							<router-view />
						</v-col>
					</v-row>
				</v-container>
			</v-main>
		</v-app>
	</div>
</template>

<script>
import toolbar from '@/components/supplier/Toolbar';
import { mapState, mapMutations } from 'vuex'

export default {
	components: {
		toolbar
	},
	props: {
		source: String,
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState(['snackbar', 'attempting']),
	},
	data: () => ({
		drawer: null,
		navbar: 256,
	}),
	methods: {
		...mapMutations(['hideSnackbar']),

		clickDrawer() {
			if (window.matchMedia('(min-width: 1264px)').matches) {
				if (this.navbar == 256) {
					this.navbar = 60
				} else {
					this.navbar = 256
				}
			} else {
				this.drawer = !this.drawer
			}
		},
	}
};
</script>